import { ApolloClient } from "@apollo/client";
import { action, autorun, computed, makeObservable, observable } from "mobx";
import Drive from "../models/Drive";
import LocalStorage from "../utils/LocalStorage";
import BaseStore from "./BaseStore";
import RootStore from "./RootStore";

type LocalLocalStorageData = {
  sortBy?: string;
  sortDirection?: string;
  view?: string;
};

const STORE_NAME = "DRIVES";

export default class DrivesStore extends BaseStore<Drive> {
  sortBy = "updatedAt";

  sortDirection = "desc";

  view = "grid";

  constructor(rootStore: RootStore, apolloClient: ApolloClient<any>) {
    super(rootStore, Drive, apolloClient);
    this.rootStore = rootStore;
    this.apolloClient = apolloClient;

    makeObservable(this, {
      sortBy: observable,
      sortDirection: observable,
      view: observable,
      // Computed
      toLocalLocalStorageData: computed,
      // Actions
      rehydrateStore: action,
      setSortBy: action,
      setSortDirection: action,
      setView: action,
    });

    const data: LocalLocalStorageData = LocalStorage.retrieve(STORE_NAME) || {};

    this.rehydrateStore(data);

    autorun(() => {
      LocalStorage.save(STORE_NAME, this.toLocalLocalStorageData);
    });
  }

  get toLocalLocalStorageData() {
    return {
      sortBy: this.sortBy,
      sortDirection: this.sortDirection,
      view: this.view,
    };
  }

  rehydrateStore(data: LocalLocalStorageData) {
    this.sortBy = data.sortBy || "updatedAt";
    this.sortDirection = data.sortDirection || "desc";
    this.view = data.view || "grid";
  }

  setSortBy = (sortBy: string) => {
    this.sortBy = sortBy;
  };

  setSortDirection = (sortDirection: string) => {
    this.sortDirection = sortDirection;
  };

  setView = (view: string) => {
    this.view = view;
  };
}
